export default {
      id: "ic_united_racing-usage",
      viewBox: "0 0 98 28",
      url: "/" + "images/icons.3.109.2.svg#ic_united_racing-usage",
      toString: function () {
        return this.url;
      }
    }